export const wearerStates = {
    tempWarning: 1,
    tempCaution: 2,
    tempIndeterminate: 3,
    lowBattery: 4,
    healthy: 7,
    newWearer: 8,
    offline: 9,
    unworn: 10,
    noStatus:11
}
